var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{staticClass:"mb-4",staticStyle:{"width":"976px"},attrs:{"height":"300","hide-delimiter-background":"","show-arrows-on-hover":""}},_vm._l((_vm.items),function(item){return _c('v-carousel-item',{key:item.id,attrs:{"src":item.src,"reverse-transition":"fade-transition","transition":"fade-transition"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }